import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Container, Row, Col } from "react-bootstrap";
import Modal from "react-modal";
import "../../styles/automation/campaign-logs.css";
import BackAddBtns from "../../components/Open-pages/target-matrics/common/BackAddBtns";
import ModalHeadAndClose from "../../components/payouts-wtf/common/ModalHeadAndClose";
import { selectAuth } from "../../components/auth/auth.selector";
import {
  fetchAllJobsData,
  fetchAllJobsState,
} from "../../redux/reducers/apiSlice";
import MealsStructure from "../../components/diet/meal/MealsStructure";
import JobLogs from "../../components/automation/job/JobLogs";
import JobForm from "../../components/automation/job/JobForm";
import JobStats from "../../components/automation/job/JobStats";
import HelmetWrapper from "../../HelmetWrapper";
import CommonStructured from "../../components/common-components/CommonStructured";

const JobSystem = () => {
  const dispatch = useDispatch();
  const authData = useSelector(selectAuth);
  const userInfoData = authData.user;

  const { allJobs, allJobsState, loading } = useSelector((state) => state.api);

  const iniModValues = {
    isModOpen: false,
  };
  const [modValues, setModValues] = useState(iniModValues);

  const [isPage, setIsPage] = useState(0);
  const iniFilters = {
    page: isPage + 1,
    limit: 10,
    job_state: "",
  };
  const [filters, setFilters] = useState(iniFilters);
  const iniTbDatas = {
    allData: [],
    pagination: [],
    jobStats: {},
  };
  const [tbDatas, setTbDatas] = useState(iniTbDatas);

  const closeModal = () => {
    setModValues(iniModValues);
  };

  const onClickModal = () => {
    setModValues((prevs) => ({ ...prevs, isModOpen: true }));
  };

  const onClickCard = (cardName, value) => {
    setFilters((prevs) => ({
      ...prevs,
      job_state: cardName === prevs.job_state ? "" : cardName,
    }));
  };

  useEffect(() => {
    setFilters((prevs) => ({
      ...prevs,
      page: isPage + 1,
    }));
  }, [isPage]);

  useEffect(() => {
    dispatch(
      fetchAllJobsState({
        filters: { type: "card" },
        token: userInfoData?.token,
      })
    );
  }, []);

  useEffect(() => {
    dispatch(
      fetchAllJobsData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  }, [filters]);

  useEffect(() => {
    if (allJobsState?.status && allJobsState?.data) {
      setTbDatas((prevs) => ({
        ...prevs,
        jobStats: allJobsState.data,
      }));
    } else {
      setTbDatas((prevs) => ({
        ...prevs,
        jobStats: {},
      }));
    }
  }, [allJobsState]);

  useEffect(() => {
    if (allJobs?.status && allJobs?.data) {
      setTbDatas((prevs) => ({
        ...prevs,
        allData: allJobs.data || [],
        pagination: allJobs?.pagination || [],
      }));
    } else {
      setTbDatas((prevs) => ({
        ...prevs,
        allData: [],
        pagination: [],
      }));
    }
  }, [allJobs]);

  return (
    <HelmetWrapper title="WTF: Job Management System">
      <Container
        className="bg-cloud-k px-50px daily-target-metrics-container r-mt30"
        fluid
      >
        <Modal
          isOpen={modValues.isModOpen}
          onRequestClose={closeModal}
          contentLabel="Add Modal"
          ariaHideApp={false}
        >
          <div className="createNewCTOModalContainer mod-width-70p mod-height-95vh">
            <ModalHeadAndClose title="Add New JOB" onClose={closeModal} />

            <JobForm
              userInfoData={userInfoData}
              closeModal={closeModal}
              callFunction={() =>
                dispatch(
                  fetchAllJobsData({
                    filters: filters,
                    token: userInfoData?.token,
                  })
                )
              }
            />
          </div>
        </Modal>

        {/* <Row>
          <Col>
            <MealsStructure text={"Campaign JOB"} />
          </Col>
        </Row> */}

        <Row>
          <Col>
            <CommonStructured
              pageHeading={"Campaign JOB"}
              createBtnTxt={"+ Add New JOB"}
              onClickCreateBtn={onClickModal}
              isReload={() => {
                dispatch(
                  fetchAllJobsState({
                    filters: { type: "card" },
                    token: userInfoData?.token,
                  })
                );
                dispatch(
                  fetchAllJobsData({
                    filters: filters,
                    token: userInfoData?.token,
                  })
                );
              }}
            />

            {/* <BackAddBtns
              addBtnTxt={"Add New JOB"}
              onClickAdd={onClickModal}
              onClickReload={() => {
                dispatch(
                  fetchAllJobsState({
                    filters: { type: "card" },
                    token: userInfoData?.token,
                  })
                );
                dispatch(
                  fetchAllJobsData({
                    filters: filters,
                    token: userInfoData?.token,
                  })
                );
              }}
              isAddBtn={true}
            /> */}
          </Col>
        </Row>

        <Row>
          <Col>
            <JobStats
              allJobStats={tbDatas.jobStats}
              onClickCard={onClickCard}
            />
          </Col>
        </Row>

        <Row>
          <Col>
            <JobLogs
              isLoading={loading}
              tbDatas={tbDatas}
              isPage={isPage}
              setIsPage={setIsPage}
              userInfoData={userInfoData}
              callFunction={() =>
                dispatch(
                  fetchAllJobsData({
                    filters: filters,
                    token: userInfoData?.token,
                  })
                )
              }
            />
          </Col>
        </Row>
      </Container>
    </HelmetWrapper>
  );
};

export default JobSystem;
